export default "__VITE_ASSET__Ci73AqMt__"